module.exports = __webpack_public_path__ + "static/media/default.9e769f6d.png";